/**
 * Main entry point for the application.
 */
console.log("Application loaded.");

/**
 * Loads SVG symbols from the server and injects them into the document body.
 */
async function loadSvgSymbols() {
	try {
		const response = await fetch("/images/symbols.svg");
		if (!response.ok) {
			throw new Error(`Failed to fetch symbols: ${response.statusText}`);
		}
		const svgText = await response.text();
		const parser = new DOMParser();
		const svgDoc = parser.parseFromString(svgText, "image/svg+xml");
		const svgElement = svgDoc.querySelector("svg");
		if (svgElement) {
			svgElement.setAttribute("aria-hidden", "true");
			svgElement.setAttribute("focusable", "false");
			document.body.prepend(svgElement);
		}
	} catch (error) {
		console.error("Error loading SVG symbols:", error);
	}
}

loadSvgSymbols();
